export const NOT_ENROLLED = 'not_enrolled';
export const OPTED_IN = 'opted_in';
export const PENDING = 'pending';
export const ENABLED = 'enabled';
export const CANCELED = 'canceled';
export const DISABLED = 'disabled';
